import { EstimateItem } from '../types';

/** Unidades que YA significaban horas antes del Esquema v4. */
const UNIDADES_HORA = new Set(['hr', 'hour', 'hours', 'hora', 'horas']);

/**
 * Fila de mano de obra guardada ANTES del Esquema v4, cuando `quantity` era la
 * medida del cliente ("2 crew-day") y no horas-hombre.
 *
 * OJO CON EL DISCRIMINADOR. No sirve `unit !== 'HR'`: hasta ayer el soltado de
 * plantilla copiaba `li.unit` tal cual, y 1.990 de las 2.135 partidas de labor
 * del corpus vienen en `'hour'` minúscula. En esas, `qty` YA eran horas-hombre,
 * así que su precio es correcto y marcarlas sería mentir. Se comprobó contra
 * producción: de 161 estimados con mano de obra, 65 traen `'hour'` (correctos)
 * y 45 traen una unidad no horaria (esos sí están mal cobrados).
 *
 * Estas 45 se quedan como se enviaron. Un estimado que salió en $190,28 no se
 * convierte en $3.044,44 porque el motor cambió: es un documento, no un cálculo
 * vivo. La insignia existe para que el contratista lo VEA y decida, no para
 * corregirlo a sus espaldas.
 */
export function isLegacyLaborRow(item: EstimateItem): boolean {
    if (item.type !== 'Labor') return false;
    // Sello del Esquema v4 presente => la fila es nueva, no hay nada que marcar.
    if (item.clientQty !== undefined || item.dropQty !== undefined) return false;
    const u = (item.unit ?? '').trim().toLowerCase();
    // Sin unidad no se puede afirmar nada; no se marca.
    if (!u) return false;
    return !UNIDADES_HORA.has(u);
}

/** Cuántas filas de un estimado están en unidades de cliente. */
export function countLegacyLaborRows(items: EstimateItem[]): number {
    return items.reduce((n, i) => n + (isLegacyLaborRow(i) ? 1 : 0), 0);
}
